import { render, staticRenderFns } from "./DeleteBrandTutorialVideoPopup.vue?vue&type=template&id=559f1c88&scoped=true&"
import script from "./DeleteBrandTutorialVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteBrandTutorialVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteBrandTutorialVideoPopup.vue?vue&type=style&index=0&id=559f1c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f1c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559f1c88')) {
      api.createRecord('559f1c88', component.options)
    } else {
      api.reload('559f1c88', component.options)
    }
    module.hot.accept("./DeleteBrandTutorialVideoPopup.vue?vue&type=template&id=559f1c88&scoped=true&", function () {
      api.rerender('559f1c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteBrandTutorialVideoPopup.vue"
export default component.exports